import * as React from "react"
import { Nav } from "shards-react"

import SocialMediaIcon from "./socialMediaIcon"
const socials = require("../data/social.json")

const SocialMediaNavigation = props => (
  <Nav style={{ marginLeft: "-15px" }}>
    {socials.map(social => (
      <SocialMediaIcon
        key={social.name}
        icon={social.icon}
        href={social.href}
      />
    ))}
  </Nav>
)

export default SocialMediaNavigation
